module.exports = __webpack_public_path__ + "img/quick-icon6.ce89ad4a.png";